import React from 'react';
import classnames from 'classnames';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const Help: React.FC = () => {
  return (
    <ul className={classnames(styles['menu'], styles['menu-ul'])}>
      <li><a href={`${routes.help}#1`}>1. Подключение к Агенту 1С:СБП</a></li>
      <ul className={styles['menu-ul']}>
        <li><a href={`${routes.help}#1.1`}>1.1. Как зарегистрироваться в Агенте 1С:СБП</a></li>
        <li><a href={`${routes.help}#1.2`}>1.2. Как восстановить пароль</a></li>
      </ul>
      <li><a href={`${routes.help}#2`}>2. Работа с организацией</a></li>
      <ul className={styles['menu-ul']}>
        <li><a href={`${routes.help}#2.1`}>2.1. Как добавить организацию</a></li>
        <li><a href={`${routes.help}#2.2`}>2.2. Как пригласить пользователя в организацию</a></li>
        <li><a href={`${routes.help}#2.3`}>2.3. Как пройти аутентификацию в Агенте 1С:СБП по ссылке-приглашению</a></li>
        <li><a href={`${routes.help}#2.4`}>2.4. Как удалить пользователя из организации</a></li>
        <li><a href={`${routes.help}#2.5`}>2.5. Как добавить банк к организации</a></li>
        <li><a href={`${routes.help}#2.6`}>2.6. Как удалить банк из организации</a></li>
        <li><a href={`${routes.help}#2.7`}>2.7. Как выйти из организации</a></li>
      </ul>
      <li><a href={`${routes.help}#3`}>3. Управление токенами</a></li>
    </ul>
  );
};

export default Help;
